/*
 * @Description:
 * @Author: Xyyyyyy
 * @Date: 2023-06-25 18:23:29
 * @LastEditors: 裴孚
 * @LastEditTime: 2023-07-03 14:16:13
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import VueUeditorWrap from 'vue-ueditor-wrap'
import VueCookies from 'vue-cookies'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// import * as echarts from 'echarts'

// import zhCn from 'element-plus/es/locale/lang/zh-cn'
import zhCn from '@/assets/js/zh-cn'
import 'dayjs/locale/zh-cn'
import 'element-plus/dist/index.css'
import '@/assets/css/main.less'
import '@/assets/iconfont/iconfont.css'

// 公共配色
import '@/assets/css/peise.less'

// 公共样式
import '@/assets/css/login.less'
import '@/assets/css/liebiao.less'
import '@/assets/css/tanchuang.less'
import '@/assets/css/windowsize.css'
// import '@/assets/bootstrapicons/bootstrap-icons.css'

// 富文本编辑器
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus, {
  locale: zhCn
})
app.use(VueUeditorWrap)
app.config.globalProperties.cookies = VueCookies

// app.config.globalProperties.$echarts = echarts
app.use(router)
app.component('QuillEditor', QuillEditor)
app.mount('#app')
